'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'swords-laser';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e03d';
var svgPathData = ['M60.4-3.5L362.1 272 309 272 60.4-3.5zM387.5 170.6L579.7-3.7 406.2 187.6c-6.2-5.7-12.4-11.4-18.6-17z', 'M406.2 187.6l35.4 32.4 177-195.1C635.7 6 635-23 617-41s-47-18.7-65.9-1.6L351.9 138.1 387.5 170.6 579.7-3.7 406.2 187.6zM280.9 391.1l-60.7-60.7c-11.4-11.4-16.8-25.3-17.5-38.9l-6.7-7.4-162 162c-18.7 18.7-18.7 49.1 0 67.9l28.1 28.1c18.7 18.7 49.1 18.7 67.9 0L280.9 391.1zm-57-10.9l-19.7 19.7-28.1-28.1 19.7-19.7 28.1 28.1zm-48 48l-79.9 79.9-28.1-28.1 79.9-79.9 28.1 28.1zM60.4-3.5L362.1 272 309 272 60.4-3.5zM21.3 24.8L250 278.2c-4.5 5.9-4.9 14.9 1.4 21.1 8 8 14.6 14.6 19.6 19.6l1 1 222.1 222.1c18.7 18.7 49.1 18.7 67.9 0l44.1-44.1c18.7-18.7 18.7-49.1 0-67.9L457.4 281.4c-6-6-14.1-9.4-22.6-9.4l-1.4 0-344.4-314.4C70.1-59.6 41-59 23-40.9 5-23 4.3 6 21.3 24.8zM528 508.1L458.9 439 503 394.9 572.1 464 528 508.1zm-103-103l-85.1-85.1 88.2 0 41 41-44.1 44.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwordsLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;